import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { useSiteConfig } from '../../contexts/SiteConfigContext';

const SocialIcon: React.FC<{ d: string }> = ({ d }) => (
  <svg viewBox="0 0 24 24" fill="currentColor" width="16" height="16"><path d={d} /></svg>
);

const SOCIAL_ICONS: Record<string, string> = {
  facebook: 'M22 12c0-5.523-4.477-10-10-10S2 6.477 2 12c0 4.991 3.657 9.128 8.438 9.878v-6.987h-2.54V12h2.54V9.797c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562V12h2.773l-.443 2.89h-2.33v6.988C18.343 21.128 22 16.991 22 12z',
  instagram: 'M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12s.014 3.668.072 4.948c.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24s3.668-.014 4.948-.072c4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948s-.014-3.667-.072-4.947c-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z',
  twitter: 'M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z',
  linkedin: 'M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 01-2.063-2.065 2.064 2.064 0 112.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z',
};

const Footer: React.FC = () => {
  const { getFooterText, getFooterCopyright, config } = useSiteConfig();

  const socialLinks = [
    { key: 'facebook', url: config?.facebook_url, label: 'Facebook' },
    { key: 'instagram', url: config?.instagram_url, label: 'Instagram' },
    { key: 'twitter', url: config?.twitter_url, label: 'Twitter' },
    { key: 'linkedin', url: config?.linkedin_url, label: 'LinkedIn' },
  ].filter(s => s.url);

  return (
    <footer className="mt-auto py-4" style={{ backgroundColor: '#f8f9fa', borderTop: '1px solid #e9ecef' }}>
      <Container>
        <Row className="align-items-center">
          <Col xs={12} md={6} className="text-center text-md-start">
            <p className="mb-2 mb-md-0 text-muted small">
              {getFooterCopyright()}
            </p>
          </Col>
          <Col xs={12} md={6} className="text-center text-md-end">
            <p className="mb-0 text-muted small">
              {getFooterText()}
            </p>
            {socialLinks.length > 0 && (
              <div className="d-flex justify-content-center justify-content-md-end gap-3 mt-2">
                {socialLinks.map(({ key, url, label }) => (
                  <a
                    key={key}
                    href={url}
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label={label}
                    className="text-muted"
                    style={{ transition: 'color 0.2s' }}
                    onMouseEnter={e => (e.currentTarget.style.color = '#3b82f6')}
                    onMouseLeave={e => (e.currentTarget.style.color = '')}
                  >
                    <SocialIcon d={SOCIAL_ICONS[key]} />
                  </a>
                ))}
              </div>
            )}
          </Col>
        </Row>
      </Container>
    </footer>
  );
};

export default Footer;